import React from 'react'
import { setDoc, collection, doc } from 'firebase/firestore'
import { db } from '../firebase'
import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTags } from '@fortawesome/free-solid-svg-icons';
const NewPost = () => {

    const [title, setTitle] = useState()
    const [desc, setDesc] = useState()
    const [loading, setLoading] = useState(false)
    const handleTitleChange = (e) =>{
        setTitle(e.target.value)
      }
      const handleDescChange = (e) =>{
        setDesc(e.target.value)
      }


    const sendPost = async() =>{
        var uuid =  crypto.randomUUID().replaceAll('-','')
        await setDoc(doc(db, "Posts", uuid), {
            post:{
                title: title,
                caption: desc,
                tags:['Hinman', ' Appalacian', 'C4'],
                status: 'Unresolved',
                down: 10,
                up: 7,
                uuid: uuid
            }
          });
          setTimeout(()=>{
            setLoading(true)
          }, [3000])
          console.log(uuid)
          setLoading(false)
    }

  return (
     <div className='dashboard'>
        <div className='title'>
            <h2>CommunityConnect.</h2>
        </div>
        <div class="mainDash">
            <div class="nPBody">
                <h1 style={{'marginTop' : '3rem', 'marginLeft':'5rem', 'fontSize':'3.5rem'}}>Create a post <span style={{'color': '#22BC83'}}>. . &nbsp;.</span></h1>
                    <div class="package" style={{'marginTop' : '7rem'}}>
                    <h4>Title:</h4> <input type='text' onChange={handleTitleChange} class="titleIn" name='title' style={{'height':'3rem'}} ></input>
                    </div>
                    <div class="package" style={{'marginTop' : '2rem'}}>
                    <h4>Description:</h4><input onChange={handleDescChange} type='text' class="titleIn" name='description' style={{'height':'27rem'}} ></input>
                    </div>
                    <div class="buttons">
                    <button className='tagButton'>Tags <FontAwesomeIcon className='tagIcon' icon={faTags} /></button>
                    <button className="newPostButton" onClick={()=>sendPost()}>Post</button>
                    </div>
            </div>
        </div>
    </div>
  )
}

export default NewPost